import { Formik } from "formik";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import styles from "./PaymentDetails.module.scss";
import NoContent from "../../../../common/NoContent/NoContent";
import CommonDatePicker from "../../../../common/Formik/DatePiker/DatePicker";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { getPaymentTransactionsAction } from "../../../../../features/user/userSlice";
import Table from "../../../../common/Table/Table";
import Button from "../../../../common/Button/Button";

const PaymentDetails = ({ cardId, activeTab }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [paymentData, setPaymentData] = useState({})

  const getPaymentTransactions = async () => {
    if (!cardId) return;
    setLoading(true);
    try {
      const payload = {
        page,
        limit: 10,
        ...(startDate && {
          month: format(new Date(startDate), "yyyy-MM"),
        }),
      };
      const res = await dispatch(getPaymentTransactionsAction(cardId, payload));
      if (res.status === 200) {
        setPaymentData(res?.data?.data)
      }
    } catch (error) {
      console.log("Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cardId || activeTab !== "paymentHistory") return;

    const noDatesSelected = !startDate;
    const bothDatesSelected = startDate;

    if (noDatesSelected || bothDatesSelected) {
      getPaymentTransactions();
    }
  }, [cardId, activeTab, startDate]);

  const handleResetDates = (formik) => {
    formik.resetForm();
    setStartDate("");
  };

  const fields = [
    { label: "Bill Number", value: "bill_number" },
    { label: "Amount", value: "amount" },
    { label: "Paid Amount", value: "paid_amount" },
    { label: "Previous Balance", value: "previous_balance" },
    { label: "Total Charges", value: "total_charges" },
    { label: "Total Payments", value: "total_payments" },
    { label: "Total Fees", value: "total_fees" },
    { label: "Status", value: "status" },
    { label: "Created At", value: "created_at" },
  ]

  return (
    <>
      <section className={styles.AmountDetails}>
        <div className={styles.recent_AmountDetails}>
          <div className={styles.recent_AmountDetails_head}>
            <h4>Payment History</h4>
            <div className={styles.recent_AmountDetails_head_rightSec}>
              <Formik
                initialValues={{
                  startdate: "",
                }}
                // onSubmit={(values) => console.log("Form Submitted:", values)}
onSubmit={(values) => {}}
>
                {(formik) => (
                  <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <CommonDatePicker
                      className="datepickerfield"
                      name="startdate"
                      value={startDate}
                      placeholder="Select Month"
                      onChange={(date) => setStartDate(date)}
                      // minDate={new Date()}
                      formik={formik}
                      showMonthYearPicker={true}
                    />
                    <Button
                      className={styles.resetBtn}
                      variant='xtra_small danger_filled'
                      type="button"
                      onClick={(e) => {
                        handleResetDates(formik);
                      }}
                      disabled={!startDate}
                    >
                      Reset
                    </Button>
                  </form>
                )}
              </Formik>

            </div>
          </div>

          <Table
            noRecordContent={"No records for your search were found."}
            fields={fields}
            className='table'
            loading={loading}
            noRecordVariant={"large"}
            noRecordClassName={styles.no_content}
            loadingClassName={"loading_table"}
          >
            {paymentData?.list?.length > 0 ?
              paymentData?.list?.map((item, index) => (
                <tr key={index}>
                  <td>{item?.bill_number}</td>
                  <td>{item?.amount}</td>
                  <td>{item?.paid_amount}</td>
                  <td>{item?.previous_balance}</td>
                  <td>{item?.total_charges}</td>
                  <td>{item?.total_payments}</td>
                  <td>{item?.total_fees}</td>
                  <td>{item?.status}</td>
                  <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
                </tr>
              )) :
              <tr>
                <td colSpan={fields.length}>
                  <NoContent
                    className={styles.no_record}
                  />
                </td>
              </tr>
            }
          </Table>
          {paymentData?.totalItems > 10 && (
            <Commonpagination
              pagination
              currentPage={paymentData?.currentPage}
              className={styles.pagination}
              pageSize={10}
              totalPages={paymentData?.totalPages}
              handlePageChange={(selected) => setPage(selected)}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default PaymentDetails;
